"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DomainObject_1 = require("./DomainObject");

var EntityStateFlag_1 = require("./EntityStateFlag");
/**
 * Domain object which can be marked with {@EntityStateFlag}.
 * @author VRu
 */


var StateDomainObject =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(StateDomainObject, _DomainObject_1$Domai);

  /**
   * @param stateFlags
   */
  function StateDomainObject(stateFlags) {
    var _this;

    _classCallCheck(this, StateDomainObject);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(StateDomainObject).call(this));
    _this.stateFlags = stateFlags;
    return _this;
  }

  _createClass(StateDomainObject, [{
    key: "isNew",
    value: function isNew() {
      return this.stateFlags.has(EntityStateFlag_1.NewEntity);
    }
  }, {
    key: "isModified",
    value: function isModified() {
      return this.stateFlags.has(EntityStateFlag_1.ModifiedEntity);
    }
  }, {
    key: "isDeleted",
    value: function isDeleted() {
      return this.stateFlags.has(EntityStateFlag_1.DeletedEntity);
    }
  }, {
    key: "isProcessed",
    value: function isProcessed() {
      return this.stateFlags.has(EntityStateFlag_1.ProcessedEntity);
    }
  }]);

  return StateDomainObject;
}(DomainObject_1.DomainObject);

exports.StateDomainObject = StateDomainObject;